<template>
  <div class="opc-cart-item--inline">
    <span v-if="is" class="opc-cart-item__text text-capitalized">{{ licenseDisplay }}</span>
    <slot v-else />
  </div>
</template>
    
<script>
import { getPlanUnitWithQuantity } from '@/common/product-unit';
import mx from './mx.vue';
export default {
  mixins: [mx],
  computed: {
    currentBoughtLicenseCount() {
      return this.mx_boughtPlan.cartInfo?.selected_number;
    },
    currentCartLincenseCount() {
      return this.mx_cartPlan.cartInfo?.selected_number;
    },
    is() {
      return this.mx_is && this.mx_isSingleIncreaseLicense;
    },
    licenseDisplay() {
      const delta = this.currentCartLincenseCount - this.currentBoughtLicenseCount;
      if (delta <= 0) return '';
      return this.$t('billing.prorated.xx_new_unit', [`+${delta}`, getPlanUnitWithQuantity(this.mx_cartPlan.unit)]);
    },
  },
};
</script>